import { geometry } from '@progress/kendo-drawing';
import { defined } from '../utils/functions.js';
import '../math/Graph.js';
import { Rect, Point } from '../math/Shapes.js';
import { deepExtend } from '../utils/deep-extend.js';
import { CompositeTransform } from './CompositeTransform.js';
import { Rotation } from './Rotation.js';
import { Translation } from './Translation.js';
import { diffNumericOptions } from './diffNumericOptions.js';

class Element {
    constructor(options) {
        this.options = deepExtend({}, this.options, options);
        this.id = this.options.id;
        this._originSize = Rect.empty();
        this._transform = new CompositeTransform();
    }
    visible(value) {
        return this.drawingContainer().visible(value);
    }
    redraw(options) {
        if (options && options.id) {
            this.id = options.id;
        }
    }
    position(x, y) {
        const options = this.options;
        if (!defined(x)) {
            return new Point(options.x, options.y);
        }
        if (defined(y)) {
            options.x = x;
            options.y = y;
        }
        else if (x instanceof Point) {
            options.x = x.x;
            options.y = x.y;
        }
        this._transform.translate = new Translation(options.x, options.y);
        this._renderTransform();
    }
    rotate(angle, center) {
        if (defined(angle)) {
            this._transform.rotate = new Rotation(angle, center.x, center.y);
            this._renderTransform();
        }
        return this._transform.rotate || Rotation.ZERO;
    }
    drawingContainer() {
        return this.drawingElement;
    }
    _renderTransform() {
        const matrix = this._transform.toMatrix();
        this.drawingContainer().transform(new geometry.Matrix(matrix.a, matrix.b, matrix.c, matrix.d, matrix.e, matrix.f));
    }
    _hover() { }
    _diffNumericOptions(options, fields) {
        return diffNumericOptions.call(this, options, fields);
    }
    _measure(force) {
        let rect;
        if (!this._measured || force) {
            const box = this._boundingBox() || new geometry.Rect([0, 0], [0, 0]);
            const startPoint = box.topLeft();
            rect = new Rect(startPoint.x, startPoint.y, box.width(), box.height());
            this._originSize = rect;
            this._originWidth = rect.width;
            this._originHeight = rect.height;
            this._measured = true;
        }
        else {
            rect = this._originSize;
        }
        return rect;
    }
    _boundingBox() {
        return this.drawingElement.rawBBox();
    }
}

export { Element };
